import { cva } from "cva";

export const headerActionsStyles = cva({
  base: "flex-1 flex items-center justify-end gap-8",
});
